module.exports = __webpack_public_path__ + "img/Logo-crm.080d3f72.png";